import React, { useState } from "react";
import "./DigitalCard.css";
import Images from "./../../Config/Images";

const GALLERY_IMAGES = [
  Images.dc_gallery_img_1,
  Images.dc_gallery_img_2,
  Images.dc_gallery_img_3,
  Images.dc_gallery_img_4,
];

const CONTACT = {
  brandName: "Zabali",
  tagline: "Transforming Wholesale Jewelry Sourcing.",
  email: "zabaliofficial@gmail.com",
  phone: "9974943699",
  whatsapp: "919974945799",
  address:
    "201, Shekh Sariya (Simni Chember), Manek Chowk Rd, near Jain Derasar, Luharni Pole, Ahmedabad, Gujarat 380001",
  mapsUrl:
    "https://www.google.com/maps/place/Zabali+Jewelex+Pvt.+limited/@23.0241946,72.5857343,17z/data=!3m1!4b1!4m6!3m5!1s0x395e8518feed87b3:0x16b471c24a06eb96!8m2!3d23.0241946!4d72.5883146!16s%2Fg%2F11lyxthxg8?entry=ttu&g_ep=EgoyMDI1MDMyNC4wIKXMDSoJLDEwMjExNjQwSAFQAw%3D%3D",
  website: "zabali.co",
  instagram: "https://instagram.com/zabali.co",
};

const APP_LINKS = {
  android:
    "https://play.google.com/store/apps/details?id=com.zabalireactnative",
  ios: "https://apps.apple.com/in/app/zabali-jewelex/id6739798054",
};

const HOURS = [
  { day: "Monday", time: "10:00 AM - 7:00 PM" },
  { day: "Tuesday", time: "10:00 AM - 7:00 PM" },
  { day: "Wednesday", time: "10:00 AM - 7:00 PM" },
  { day: "Thursday", time: "10:00 AM - 7:00 PM" },
  { day: "Friday", time: "10:00 AM - 7:00 PM" },
  { day: "Saturday", time: "10:00 AM - 7:00 PM" },
  { day: "Sunday", time: "Closed" },
];

function escapeVCard(value) {
  return value
    .replace(/\\/g, "\\\\")
    .replace(/,/g, "\\,")
    .replace(/;/g, "\\;")
    .replace(/\n/g, "\\n");
}

function handleSaveContact() {
  const website = /^https?:\/\//i.test(CONTACT.website)
    ? CONTACT.website
    : "https://" + CONTACT.website;

  const vCardLines = [
    "BEGIN:VCARD",
    "VERSION:3.0",
    "N:;" + escapeVCard(CONTACT.brandName) + ";;;",
    "FN:" + escapeVCard(CONTACT.brandName),
    "ORG:" + escapeVCard(CONTACT.brandName),
    "TEL;TYPE=WORK,VOICE:" + CONTACT.phone,
    "EMAIL;TYPE=WORK:" + CONTACT.email,
    "ADR;TYPE=WORK:;;" + escapeVCard(CONTACT.address) + ";;;;",
    "URL:" + website,
    "END:VCARD",
  ];

  const vCardText = vCardLines.join("\r\n");
  const blob = new Blob([vCardText], { type: "text/vcard;charset=utf-8" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = CONTACT.brandName.replace(/\s+/g, "-") + ".vcf";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export default function DigitalCard() {
  const todayName = new Date().toLocaleDateString("en-US", { weekday: "long" });
  const [shareOpen, setShareOpen] = useState(false);
  const [shareNumber, setShareNumber] = useState("");
  const [shareError, setShareError] = useState("");

  const handleSendWhatsApp = () => {
    const digitsOnly = shareNumber.replace(/[^\d]/g, "");

    if (digitsOnly.length < 10) {
      setShareError(
        "Enter a valid number with country code (e.g. 91XXXXXXXXXX).",
      );
      return;
    }

    const cardUrl = window.location.href;
    const message = `Check out ${CONTACT.brandName}'s digital card: ${cardUrl}`;
    const waUrl = `https://wa.me/${digitsOnly}?text=${encodeURIComponent(message)}`;

    window.open(waUrl, "_blank", "noopener,noreferrer");
    setShareOpen(false);
    setShareNumber("");
    setShareError("");
  };

  return (
    <div className="dc-body">
      <div className="dc-card">
        <div className="dc-banner">
          <img src={Images.dc_banner} alt="Zabali banner" />
        </div>

        <div className="dc-identity">
          <div className="dc-logo">
            <img src={Images.dc_logo} alt="Zabali logo" />
          </div>
          <div className="dc-brand-name">{CONTACT.brandName}</div>
          <div className="dc-tagline">{CONTACT.tagline}</div>
        </div>

        <div className="dc-divider">
          <div className="dc-line" />
          <div className="dc-mark" />
          <div className="dc-line" />
        </div>

        <div className="dc-btn-row">
          <button
            className="dc-save-btn"
            type="button"
            onClick={handleSaveContact}
          >
            Save contact
          </button>
          <button
            className="dc-share-btn"
            type="button"
            aria-label="Share card via WhatsApp"
            onClick={() => setShareOpen(true)}
          >
            <svg
              viewBox="0 0 24 24"
              width="20"
              height="20"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.6"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="18" cy="5" r="2.6" />
              <circle cx="6" cy="12" r="2.6" />
              <circle cx="18" cy="19" r="2.6" />
              <path d="M8.3 10.7 15.7 6.3" />
              <path d="M8.3 13.3 15.7 17.7" />
            </svg>
          </button>
        </div>

        {shareOpen && (
          <div className="dc-share-overlay" onClick={() => setShareOpen(false)}>
            <div
              className="dc-share-modal"
              onClick={(e) => e.stopPropagation()}
            >
              <h3>Send my card via WhatsApp</h3>
              <p>
                Enter a number and we'll open WhatsApp with the card link ready
                to send.
              </p>
              <input
                type="tel"
                inputMode="numeric"
                className="dc-share-input"
                placeholder="e.g. 919974945799"
                value={shareNumber}
                onChange={(e) => {
                  setShareNumber(e.target.value);
                  if (shareError) setShareError("");
                }}
              />
              {shareError && <div className="dc-share-error">{shareError}</div>}
              <div className="dc-share-actions">
                <button
                  type="button"
                  className="dc-share-cancel"
                  onClick={() => setShareOpen(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="dc-share-send"
                  onClick={handleSendWhatsApp}
                >
                  Send
                </button>
              </div>
            </div>
          </div>
        )}

        <div className="dc-quick-actions">
          <a
            href={`https://wa.me/${CONTACT.whatsapp}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="dc-ico">
              <svg
                viewBox="0 0 24 24"
                width="18"
                height="18"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M12 3.5c-4.7 0-8.5 3.6-8.5 8 0 1.4.4 2.7 1 3.9L3.5 20l4.8-1.2c1.1.6 2.4.9 3.7.9 4.7 0 8.5-3.6 8.5-8s-3.8-8-8.5-8Z" />
                <path d="M9.1 9.4c.1-.3.3-.4.5-.4h.3c.2 0 .3.1.4.3.1.3.4.9.5 1 0 .1.1.2 0 .3-.1.2-.1.2-.2.3-.1.2-.2.2-.3.3-.1.1-.2.2-.1.4.1.2.5.8 1.1 1.3.7.6 1.3.8 1.5.9.2.1.3.1.4-.1.1-.1.4-.5.6-.6.1-.2.3-.1.4-.1l1 .5c.1.1.2.1.3.2.1.1.1.6-.1 1-.2.4-1 .8-1.4.9-.4.1-.8.1-2.4-.6-2-1-3.3-2.9-3.4-3-.1-.2-.9-1.1-.9-2.2 0-1 .5-1.5.8-1.8Z" />
              </svg>
            </span>
            WhatsApp
          </a>
          <a href={`tel:${CONTACT.phone}`}>
            <span className="dc-ico">
              <svg
                viewBox="0 0 24 24"
                width="18"
                height="18"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M6.6 10.8c1.4 2.8 3.8 5.2 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.3 21 3 13.7 3 4.9c0-.6.4-1 1-1h3.4c.6 0 1 .4 1 1 0 1.2.2 2.4.6 3.6.1.4 0 .8-.2 1L6.6 10.8Z" />
              </svg>
            </span>
            Call
          </a>
          <a href={CONTACT.instagram} target="_blank" rel="noopener noreferrer">
            <span className="dc-ico">
              <svg
                viewBox="0 0 24 24"
                width="18"
                height="18"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect x="3.5" y="3.5" width="17" height="17" rx="5" />
                <circle cx="12" cy="12" r="4" />
                <circle
                  cx="16.9"
                  cy="7.1"
                  r="0.6"
                  fill="currentColor"
                  stroke="none"
                />
              </svg>
            </span>
            Instagram
          </a>
          <a
            href={`https://${CONTACT.website}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="dc-ico">
              <svg
                viewBox="0 0 24 24"
                width="18"
                height="18"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="12" cy="12" r="8.5" />
                <path d="M3.5 12h17" />
                <path d="M12 3.5c2.2 2.3 3.4 5.3 3.4 8.5s-1.2 6.2-3.4 8.5c-2.2-2.3-3.4-5.3-3.4-8.5S9.8 5.8 12 3.5Z" />
              </svg>
            </span>
            Website
          </a>
        </div>

        <div className="dc-section">
          <h2>About us</h2>
          <p>
            Zabali is a B2B jewellery platform connecting trusted manufacturers
            with retailers, making jewellery sourcing simpler, smarter, and more
            seamless.
          </p>
        </div>

        <div className="dc-section">
          <h2>Browse jewellery catalogue</h2>
          <div className="dc-qr-wrap">
            <a
              className="dc-qr-item"
              href={APP_LINKS.android}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={Images.androidQrIcon} alt="Download on Android" />
              <span>Android</span>
            </a>
            <a
              className="dc-qr-item"
              href={APP_LINKS.ios}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={Images.iosQrIcon} alt="Download on iOS" />
              <span>iOS</span>
            </a>
          </div>
        </div>

        <div className="dc-section">
          <h2>Why Choose Zabali?</h2>
          <div className="dc-services">
            {[
              "Digital Cataloging",
              "100% Hallmarked",
              "Verified Suppliers",
              "Secure Logistics",
              "Real-Time Price Updates",
            ].map((s) => (
              <div className="dc-service" key={s}>
                <strong>{s}</strong>
              </div>
            ))}
          </div>
        </div>

        <div className="dc-section">
          <h2>Gallery</h2>
          <div className="dc-gallery">
            {GALLERY_IMAGES.map((src, i) => (
              <div className="dc-ph" key={`gallery-${i}`}>
                <img src={src} alt={`Zabali gallery photo ${i + 1}`} />
              </div>
            ))}
          </div>
          <div className="dc-gallery-hint">Swipe to view more &#8594;</div>
        </div>

        <div className="dc-section">
          <h2>Contact</h2>
          <div className="dc-contact-list">
            <div className="dc-contact-row">
              <div className="dc-ico-box">@</div>
              <div>
                <div className="dc-label">Email</div>
                <a
                  className="dc-value dc-value-link"
                  href={`mailto:${CONTACT.email}`}
                >
                  {CONTACT.email}
                </a>
              </div>
            </div>
            <div className="dc-contact-row">
              <div className="dc-ico-box">&#9742;</div>
              <div>
                <div className="dc-label">Phone</div>
                <a
                  className="dc-value dc-value-link"
                  href={`tel:${CONTACT.phone}`}
                >
                  {CONTACT.phone}
                </a>
              </div>
            </div>
            <div className="dc-contact-row">
              <div className="dc-ico-box">&#8962;</div>
              <div>
                <div className="dc-label">Address</div>
                <a
                  className="dc-value dc-value-link"
                  href={CONTACT.mapsUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {CONTACT.address}
                </a>
              </div>
            </div>
            <div className="dc-contact-row">
              <div className="dc-ico-box">&#8734;</div>
              <div>
                <div className="dc-label">Website</div>
                <a
                  className="dc-value dc-value-link"
                  href={`https://${CONTACT.website}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {CONTACT.website}
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="dc-section">
          <h2>Office hours</h2>
          <div className="dc-hours">
            {HOURS.map((h) => {
              const isToday = h.day === todayName;
              return (
                <div
                  className={`dc-hours-row${isToday ? " dc-today" : ""}`}
                  key={h.day}
                >
                  <span>{h.day}</span>
                  <span>{h.time}</span>
                </div>
              );
            })}
          </div>
        </div>

        <a
          className="dc-review-btn"
          href="https://www.google.com/search?q=Zabali+Jewelex+Pvt.+Limited+Reviews"
          target="_blank"
          rel="noopener noreferrer"
        >
          Rate us on Google &#8594;
        </a>

        <div className="dc-footer">Zabali digital card</div>
      </div>
    </div>
  );
}
